import { z } from 'zod/v4';

import { teamConfigSchema, teamConfigUpdateSchema } from '../team-config';
import { columns } from './columns';

export const teamSchema = z.object(columns);

export type Team = z.output<typeof teamSchema>;

export const teamWithConfigSchema = z.object({
  ...teamSchema.pick({
    uuid: true,
    teamCode: true,
    teamName: true,
  }).shape,
  currentTeamConfig: teamConfigSchema.pick({
    active: true,
    daysUntilExpiration: true,
    daysUntilExpectedWin: true,
    quotePdfType: true,
    quoteEmailSettings: true,
    quoteEmailTemplate: true,
    quoteIdPrefix: true,
    alphaEmbedTeam: true,
    uuid: true,
  }),
});

export type TeamWithConfig = z.output<typeof teamWithConfigSchema>;

export const teamWithConfigUpdateSchema = z.object({
  ...teamSchema.pick({
    uuid: true,
    teamCode: true,
    teamName: true,
  }).shape,
  currentTeamConfig: z.object(teamConfigUpdateSchema),
});

export type TeamFundamentals = Pick<Team, 'uuid' | 'teamCode' | 'teamName'>;

export const updateTeamWithConfigSchema = z.object({
  ...teamWithConfigSchema.shape,
  currentTeamConfig: {
    ...teamConfigUpdateSchema,
    quotePdfType: z.string(),
  },
});

export type UpdateTeamWithConfig = z.output<typeof updateTeamWithConfigSchema>;
